function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M48.972 12.21l.009.01.009.01 7.79 8.214-.071 53.293a.287.287 0 01-.287.287H1.287A.287.287 0 011 73.737V2.27c0-.159.13-.288.289-.286l38.758.31 8.925 9.915z",
  fill: "#fff",
  stroke: "#E5E5E5",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.707 2.186v18.475c0 .473.384.857.858.857H56.19",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeDasharray: "1.12 1.12"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.164 12.805h15.071M13.746 20.376h15.07",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.746 27.947H35.89M13.746 64.903H35.89",
  stroke: "#EBB55C",
  strokeWidth: 1.232,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.164 35.518H20.62",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.746 43.09h8.4M13.746 50.66h12.218",
  stroke: "#EBB55C",
  strokeWidth: 1.232,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M59.423 18.187l.008.01.01.009 7.79 8.214-.072 53.294a.287.287 0 01-.286.286H11.737a.287.287 0 01-.286-.287V8.248c0-.16.13-.288.289-.287l38.758.31 8.925 9.916z",
  fill: "#fff",
  stroke: "#C5C5C5",
  strokeWidth: 2
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.179 19.422h18.235",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M17.826 14.523H33.7",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeDasharray: "4.06 4.06"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M18.179 24.322h26.267",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M18.179 29.22h4.776",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M25.994 29.22h11.614",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M20.132 34.12H30.77",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M33.809 34.12h1.845",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M20.132 39.02h8.683",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M31.855 39.02H52.26",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M20.132 43.919h4.342",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M27.839 43.919h15.63",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M22.086 48.818h14.327",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M39.561 48.818h6.838",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M24.04 53.717h6.729",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7 53.717h1.954",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M18.179 58.616h4.776",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M25.994 58.616h11.614",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M20.132 63.516H30.77",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M33.809 63.516h1.845",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M20.132 68.415h8.683",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M31.855 68.415H52.26",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M20.132 73.314h4.342",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M27.839 73.314h15.63",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M49.953 8.203v18.515c0 .474.384.858.858.858h16.538",
  stroke: "#C5C5C5",
  strokeWidth: 2
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fill: "#323232",
  d: "M19.055 31.734h36.881v4.917H19.055zM20.899 51.404h23.358v4.917H20.899zM17.211 16.736h23.358v4.917H17.211zM19 66h35v5H19zM19.055 41.569h36.881v4.917H19.055z"
});

var SvgRedact = function SvgRedact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 81,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
};

export default "data:image/svg+xml;base64,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";
export { SvgRedact as ReactComponent };